var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ActionGeneric',{attrs:{"to":_vm.to,"label":"Modifica","iconClass":"fas fa-pen","eventName":_vm.eventName,"btnClasses":_vm.btnClasses,"btnClassesMobile":_vm.btnClassesMobile,"disabled":_vm.disabled}})}
var staticRenderFns = []

export { render, staticRenderFns }